import axios from 'axios'
import moment from 'moment'
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'
import ReactPaginate from 'react-paginate'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useDebounce, KTSVG } from '../../../../../_metronic/helpers'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import { startLoadding } from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import { AuthenticateUser } from '../../../../Utils/_helpers/RoleAndPermission'
import {
  DeleteData,
  GetAllData,
  GetFilterContactSegment,
} from '../Segments/SegmentSlice/SegmentSlice'
import CreateSegmentPopup from './Modal/CreateSegmentPopup'
import InsertNewData from '../../../../Components/InsertNewData'
import ViewSegmentPopup from './Modal/ViewSegmentPopup'
import { ENV } from '../../../../Utils/_helpers/EnvHelper'
import { toast } from 'react-toastify'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import SegmentFilter from './SegmentFilter'
import {useResponsive} from '../../../../hooks/useResponsive'
import {SegmentMobileCard} from './SegmentMobileCard'
import './SegmentList.scss'

interface SegmentListPageProps {
  newNavigation?: boolean
  setTotal?: (value?: number) => void
}

export type GetSegmentParams = {
  page?: number
  size?: number
  search?: string
}

const SegmentList: FC<SegmentListPageProps> = ({ newNavigation, setTotal }) => {
  const API_URL = ENV().REACT_APP_API_URL
  const API_DOMAIN = ENV().REACT_APP_DOMAIN

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {isMobile} = useResponsive()
  const Segmentlist = useSelector((state: any) => state?.SegmentData?.segmaent?.data?.items)
  const SegmentResult = useSelector((state: any) => state?.SegmentData?.segmaent?.data)
  const countOfsegment: any[] = useSelector((state: any) => state?.SegmentData?.counts?.data)

  const [segmentData, setSegmentData] = useState({})
  const [newSegmentData, setNewSegmentData] = useState({})
  const [createSegment, setCreateSegment] = useState(false)
  const [viewSegment, setViewSegment] = useState(false)
  //Delete All state
  const [checkList, setCheckList] = useState<any>([])
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deleteIds, setDeleteIds] = useState<any>()

  const [params, setParams] = useState<GetSegmentParams>({
    page: 1,
    size: 10,
    search: '',
  })

  const debouncedSearchTerm = useDebounce(params?.search, 3000)
  useEffect(() => {
    dispatch(startLoadding())
    dispatch(GetAllData(params))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm, params.page, params.size])

  useEffect(() => {
    if (confirm === true) {
      dispatch(
        DeleteData({
          segmentIds: [...deleteIds],
        })
      )
      setConfirm(false)
      setCheckList([])
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirm])

  useEffect(() => {
      if (setTotal &&  SegmentResult?.total !== undefined) {
        setTotal(SegmentResult?.total ?? 0)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SegmentResult?.total])

  const createSegmentPopup = useMemo(
    () => (
      <CreateSegmentPopup
        segmentData={segmentData}
        setNewSegmentData={setNewSegmentData}
        setSegmentData={setSegmentData}
        show={createSegment}
        handleClose={() => setCreateSegment(false)}
        handleOpenContects={() => setViewSegment(true)}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [createSegment]
  )

  const viewSegmentModel = useMemo(
    () => (
      <ViewSegmentPopup
        segmentData={segmentData}
        newSegmentData={newSegmentData}
        setNewSegmentData={setNewSegmentData}
        setSegmentData={setSegmentData}
        show={viewSegment}
        handleClose={() => setViewSegment(false)}
        handleOpenCreate={() => setCreateSegment(true)}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewSegment]
  )

  const handleEdit = (val: any) => {
    setSegmentData(val)
    setCreateSegment(true)
  }

  const handleDeleteAll = () => {
    setOpen(true)
    setDeleteIds(checkList)
  }

  const handleSingleDelete = (id: any) => {
    setOpen(true)
    setDeleteIds([id])
  }

  const handleCheckAll = () => {
    if (checkList?.length === Segmentlist?.items?.length) {
      setCheckList([])
    } else {
      let list = Segmentlist?.items?.map((key: any) => key._id)
      setCheckList([...list])
    }
  }

  const handleCheck = (e: any) => {
    if (checkList?.includes(e.target.value)) {
      checkList.splice(checkList?.indexOf(e.target.value), 1)

      setCheckList([...checkList])
    } else {
      setCheckList([...checkList, e.target.value])
    }
  }

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        page={params}
        show={open}
        handleClose={() => setOpen(false)}
        checklist={() => setCheckList([])}
        Message={'Are you sure, you want to delete Segment?'}
        confirm={() => setConfirm(true)}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [open]
  )
  const handleExport = (e: any) => {
    axios
      .get(`${API_URL}segment/exportSegmentContacts/${e}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      })
      .then((res: any) => {
        window.open(`${API_DOMAIN}${res.data.data.downloadurl}`, '_self')
      })
  }

  const getSegmentCounsts = useCallback((key: string, id: string) => {
    if (!countOfsegment?.length || !id || !key) {
      return '..counting'
    }
    const segmentData = countOfsegment.find((item: any) => item?.id === id)
    const count = segmentData?.[key] ?? 0
    return count
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newSegmentData])

  return (
    <>
      {createSegmentPopup}
      {viewSegmentModel}

      {confirmation}

      <div className='card mb-0'>
        <div className={`card-header border-0 pt-9 ${isMobile ? 'px-4' : 'px-9'} d-flex flex-column ${isMobile ? 'segment-list-header-mobile' : ''}`}>
          {!newNavigation ? (
            <h3 className='card-title align-items-start flex-column'>
              <div>
                <span className='fw-bolder fs-2 mb-1' data-testid='titlePage'>Segments</span>
                <OverlayTrigger
                  placement='bottom'
                  overlay={<Tooltip id="tooltip-bottom">
                    <div style={{ textAlign: "left" }}>
                      <span>A segment is a dynamic group of contacts defined by shared charasteritics or behaviors.</span> <br />
                      <span>It allows to you to automatically group contacts based on things like :</span>
                      <ul className="mb-0 ps-3 mt-3">
                        <li>Tags or labels (e.g., VIP Costumers, past buyers)</li>
                        <li>Custom fields (e.g., state, preferred brand, purchase date)</li>
                        <li>Actions (e.g., clicked a link, replied to a campaign, opted in)</li>
                      </ul>
                    </div>
                  </Tooltip>}
                >
                  <i
                    className='m-2 svg-icon-3 svg-icon-gray-500 cursor-pointer bi-info-circle'
                  />
                </OverlayTrigger>
              </div>
              <span className='text-muted mt-1 fw-bold fs-7'>Here you can see all your segments</span>
            </h3>
          ) : null}
          <div className={`d-flex ${isMobile ? 'flex-column gap-3' : 'justify-content-between align-items-center'}`}>
            <SegmentFilter params={params} setParams={setParams} doFetch={() => dispatch(GetAllData(params))} />
            {AuthenticateUser('create-segment') && (
              <div className={isMobile ? 'w-100' : 'ms-auto'}>
                <div className={`d-flex gap-3 align-items-center ${isMobile ? 'w-100' : ''}`}>
                  <button
                    className={`btn btn-primary ${isMobile ? 'flex-fill' : ''}`}
                    onClick={() => {
                      setSegmentData({})
                      setCreateSegment(true)
                    }}
                  >
                    <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                    Create
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        {Segmentlist?.length > 0 ? (
          <div className={`card-body pt-2 ${isMobile ? 'px-4' : ''}`}>
            <div className='tab-content'>
              {isMobile ? (
                <div className='mobile-segments-list'>
                  {Segmentlist?.map((val: any, i: number) => {
                    const segmentCount =
                      countOfsegment?.length > 0
                        ? countOfsegment?.find((key: any) => key?.id == val?._id)?.count
                        : '..counting'
                    return (
                      <SegmentMobileCard
                        key={i}
                        segment={val}
                        count={segmentCount}
                        onEdit={handleEdit}
                        onDelete={handleSingleDelete}
                        onExport={handleExport}
                        onViewContacts={(segment) => {
                          navigate('/segmentfilterContact', {state: segment})
                          dispatch(GetFilterContactSegment({id: segment._id}))
                        }}
                      />
                    )
                  })}
                </div>
              ) : (
                /* Desktop view: Table layout */
                <div className='table-responsive'>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead data-testid='headerTableSegments'>
                      <tr className='fw-bold text-muted text-uppercase'>
                        <th>SEGMENT NAME</th>
                        <th>DATE</th>
                        <th>LAST UPDATE</th>
                        <th>SUBSCRIBE</th>
                        <th>UNSUBSCRIBE</th>
                        <th>TOTAL</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody className='text-gray-600' data-testid='bodyTabelSegment'>
                      {Segmentlist?.map((val: any, i: number) => (
                        <tr key={i}>
                          <td
                            className='cursor-pointer'
                            onClick={() => {
                              navigate('/segmentfilterContact', { state: val })
                              dispatch(GetFilterContactSegment({ id: val?._id }))
                            }}
                          >
                            {val?.name}
                          </td>
                          <td>{moment(val?.createdAt).format('DD/MM/YYYY')}</td>
                          <td>{moment(val?.createdAt).format('DD/MM/YYYY')}</td>
                          <td>
                            {getSegmentCounsts('subscribe', val?._id)}
                          </td>
                          <td>
                            {getSegmentCounsts('unsubscribe', val?._id)}
                          </td>
                          <td>
                            {getSegmentCounsts('count', val?._id)}
                          </td>
                          <td>
                            <div className='row'>
                              {AuthenticateUser('send-quick-sms') && (
                                <div
                                  className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3'
                                  onClick={() => {
                                    navigate(`/new-message`, {
                                      state: {
                                        selectedType: 'segmentOrTags',
                                        data: `segment_${val?._id}`,
                                      },
                                    })
                                  }}
                                >
                                  <span className='svg-icon svg-icon-3'>
                                    <KTSVG
                                      path='/media/icons/duotune/art/rocket.svg'
                                      className='svg-icon-3'
                                    />
                                  </span>
                                </div>
                              )}
                              {AuthenticateUser('edit-segment') && (
                                <div
                                  className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3'
                                  onClick={() => handleEdit(val)}
                                >
                                  <span className='svg-icon svg-icon-3'>
                                    <i className='bi bi-pencil-fill'></i>
                                  </span>
                                </div>
                              )}
                              <span
                                className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                data-kt-menu-trigger='hover'
                                data-kt-menu-placement='bottom-end'
                              >
                                <i className='bi bi-three-dots fs-5'></i>
                              </span>
                              <div
                                className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-150px py-4'
                                data-kt-menu='true'
                              >
                                {AuthenticateUser('segments-list') && (
                                  <div
                                    className='menu-item px-3'
                                    onClick={() => {
                                      navigate('/segmentfilterContact', { state: val })
                                      dispatch(GetFilterContactSegment({ id: val?._id }))
                                    }}
                                  >
                                    <span className='menu-link px-3'>View Contacts</span>
                                  </div>
                                )}

                                {AuthenticateUser('export-segment-based-contacts') && (
                                  <div
                                    onClick={() => handleExport(val?._id)}
                                    className='menu-item px-3'
                                  >
                                    <span className='menu-link px-3 aside-footer flex-column-auto'>
                                      Export as CSV
                                    </span>
                                  </div>
                                )}

                                <div className='menu-item px-3'>
                                  <span
                                    className='menu-link px-3'
                                    onClick={() => {
                                      navigator.clipboard.writeText(val?._id)
                                      toast.success('Successfully copied segment id')
                                    }}
                                    data-kt-users-table-filter='copy_row'
                                  >
                                    Copy ID
                                  </span>
                                </div>

                                {AuthenticateUser('delete-segment') && !val?.isInBuild && (
                                  <div className='menu-item px-3'>
                                    <span
                                      className='menu-link px-3 text-danger mb-0'
                                      onClick={() => handleSingleDelete(val?._id)}
                                      data-kt-users-table-filter='delete_row'
                                    >
                                      Delete Segment
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              <div className={`abcd ${isMobile ? 'px-0' : ''}`}>
                <select onChange={(e: any) => setParams({ ...params, size: e.target.value, page: 1 })} value={params.size}>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={SegmentResult?.total}>ALL</option>
                </select>
                <ReactPaginate
                  previousLabel='<'
                  nextLabel='>'
                  pageCount={SegmentResult?.totalPages}
                  onPageChange={(e) => setParams({ ...params, page: e.selected + 1 })}
                  containerClassName={'pagiantion'}
                  previousLinkClassName={'pagination__link'}
                  nextLinkClassName={'pagination__link'}
                  disabledClassName={'pagination__link--disabled'}
                  activeClassName={'pagination__link--active'}
                />
              </div>
            </div>
          </div>
        ) : (
          <InsertNewData
            message={{
              title: `Not contacts in your segment`,
              subtitle: `You can edit the rules to make sure you have contacts in your segment`,
            }}
            buttonName={{
              name: 'Edit rules',
              link: '',
              popup: true,
              buttonFun: () => setCreateSegment(true),
            }}
          />
        )}
      </div>
    </>
  )
}

export default SegmentList
